import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AccountService, AuthService } from '@okcargo-apps/shared-application-ionic';
import { AppTab, ECapabilities } from '@okcargo-apps/shared-domain-ionic';

export const loginGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const accountService = inject(AccountService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const dashboardUrlTree = router.createUrlTree([`/tabs/${AppTab.DASHBOARD}`]);

  try {
    // The session is resolved in one place (AuthService): this guard only decides whether the login
    // is allowed or the user goes back to the dashboard.
    const resolution = await authService.resolveSession();

    if (resolution === 'no-credentials' || resolution === 'rejected') {
      // There is no session to go back to: the login is allowed. This is also what keeps the guard
      // from bouncing with the auth guard after a session is cleared (e.g. an expired refresh token).
      return true;
    }

    return accountService.hasCapability(ECapabilities.AUTHENTICATED) ? dashboardUrlTree : true;
  } catch (error) {
    return true;
  }
};
